type MarkdownContentProps = {
	contentHtml: string;
	className?: string;
};

export default function MarkdownContent({
	contentHtml,
	className,
}: MarkdownContentProps) {
	return (
		<div
			className={
				"prose mx-auto w-full max-w-none min-w-0 break-words text-ink-2 " +
				"prose-headings:font-mono prose-headings:font-semibold prose-headings:tracking-[-0.01em] prose-headings:text-ink " +
				"prose-p:leading-relaxed prose-strong:text-ink prose-a:font-medium prose-a:text-link prose-a:underline-offset-4 " +
				"prose-code:font-mono prose-code:text-ink prose-code:before:content-none prose-code:after:content-none " +
				"[&_:not(pre)>code]:break-words [&_:not(pre)>code]:whitespace-pre-wrap [&_:not(pre)>code]:bg-paper-3 [&_:not(pre)>code]:px-1 " +
				"prose-pre:max-w-full prose-pre:overflow-x-auto prose-pre:whitespace-pre prose-pre:break-normal prose-pre:rounded-none prose-pre:border prose-pre:border-rule-2 prose-pre:bg-paper-3 prose-pre:text-ink " +
				"[&_pre_code]:whitespace-pre [&_pre_code]:break-normal " +
				"prose-blockquote:border-l-lilac-ink prose-blockquote:text-ink-2 prose-hr:border-dashed prose-hr:border-rule-2 " +
				"prose-img:border prose-img:border-rule-2 prose-img:object-cover " +
				(className ? ` ${className}` : "")
			}
			dangerouslySetInnerHTML={{ __html: contentHtml }}
		/>
	);
}
